import axios from "axios";
import { store } from "src/store/store";
import actions from "src/store/auth/actions";
import commonActions from "src/store/common/actions";
import IntlMessages from "src/hooks/utils/IntlMessages";
import { toast } from "react-toastify";

const instance = axios.create({
  headers: {
    "content-type": "application/json",
    "ApplicationKey": process.env.REACT_APP_APP_KEY
  },
});

const getToken = () => store.getState().auth.session || localStorage.getItem("act");

instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    const lang = store.getState().common.lang;

    if (token != null && token !== "") {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.Language = lang;

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    store.dispatch(commonActions.setAPICallExecuted())   

    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    let tokenRefreshingFailed = store.getState().auth.tokenRefreshingFailed;

    if (error.response.status === 403 || tokenRefreshingFailed) {
      return store.dispatch(actions.logoutUser());
    } 
    else if (error.response.status === 400){
      console.log(error?.response?.data);
      const id = error?.response?.data?.ExceptionCode;
      if (id) {
        const message = <IntlMessages id={id} />;
        console.log(message)
        toast(message);
      }
    }
    else if ((error.response.status === 401)) {
      let isTokenRefreshing = store.getState().auth.isTokenRefreshing;

      if(!isTokenRefreshing){
          store.dispatch(actions.setRefreshingToken(true))

          try {            
            const accessToken = localStorage.getItem("act");
            const refreshToken = localStorage.getItem("rft");
            
            const { data, status } = await instance.post("/services/rcp/profile/auth/RefreshSession", {
              AccessToken: accessToken,
              RefreshToken: refreshToken,
            });

            if(status !== 200){
              store.dispatch(actions.setRefreshingTokenFailed(true))
            }
            
            localStorage.setItem("act", data.data.accessToken);
            localStorage.setItem("rft", data.data.refreshToken);  

            store.dispatch(actions.setRefreshingToken(false))

            return instance(originalRequest);
          } catch (_error) {  
            return store.dispatch(actions.setRefreshingTokenFailed(true))
          }
      } else
        return instance(originalRequest);
    } else {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        // toast.error(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        // toast.error(error.request.responseText);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
        // toast.error(error.message);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
